import React, { useCallback, useContext, useState } from 'react';
import { FirebaseContext } from '../../../context/firebase';
import * as PROJECT_CODE from '../../../constants/projectCode';
import * as ORIGINAL_HREF from '../../../constants/originalHref';

function HelloOauth() {
	const { firebase } = useContext(FirebaseContext);

	var oAuthDoneOnce = false;

	const getAccessTokenFromRefresh = async (refreshToken) => {
		var toSend = { oAuthRefreshToken: refreshToken };
		//var helloRefreshToken = data["oAuthRefreshToken"];

		var getHelloAccessToken = await firebase
			.functions()
			.httpsCallable('HelloRefreshToken');

		await getHelloAccessToken(toSend).then((result) => {
			// console.log('hello oauth results: ' + JSON.stringify(result));
			//helloAuthToken = result;
			ORIGINAL_HREF.originalHREF['access_token'] =
				result['data']['access_token'];
			ORIGINAL_HREF.originalHREF['refresh_token'] =
				result['data']['refresh_token'];
			ORIGINAL_HREF.originalHREF['expires_in'] = result['data']['expires_in'];
			ORIGINAL_HREF.originalHREF['currentTime'] = Date.now();
		});

		var currentUserId = firebase.auth().currentUser.uid;

		console.log(
			'Refresh Token: ' + ORIGINAL_HREF.originalHREF['refresh_token']
		);

		ORIGINAL_HREF.originalHREF &&
			(await firebase
				.database()
				.ref('/users/' + currentUserId + '/helloSignRefreshToken')
				.set(ORIGINAL_HREF.originalHREF['refresh_token']));
	};

	const checkIfUserHasAnAccount = async () => {
		var currentUserId = firebase.auth().currentUser.uid;
		var currentRefreshToken;
		var userIsAuthorized = false;

		await firebase
			.database()
			.ref('/users/' + currentUserId)
			.once('value', (snapshot) => {
				if (
					snapshot.val().helloSignRefreshToken !== null &&
					snapshot.val().helloSignRefreshToken !== undefined
				) {
					console.log(
						'Hello sign refresh token found ' +
							snapshot.val().helloSignRefreshToken
					);
					currentRefreshToken = snapshot.val().helloSignRefreshToken;
					ORIGINAL_HREF.originalHREF['refresh_token'] = currentRefreshToken;
					userIsAuthorized = true;
				}
			});

		if (userIsAuthorized === false) {
			var userEmail = firebase.auth().currentUser.email;

			console.log('User not authorized Email ' + userEmail);

			var thisInfo = { info: userEmail };

			var checkUserHasHelloSign = await firebase
				.functions()
				.httpsCallable('HelloCreateNewUser');
			//HelloOauthCheckIfUserExists
			//HelloCreateNewUser
			var hasHelloSign;

			await checkUserHasHelloSign(thisInfo)
				.then((result) => {
					console.log('results: ' + JSON.stringify(result.data.info));
					hasHelloSign = result.data;
				})
				.catch(function (error) {
					console.log('Error ' + error);
				});

			if (hasHelloSign.info === 'goToAuth') {
				console.log('Url to go to now? ' + hasHelloSign.urlRedirect);
				//https://app.hellosign.com/oauth/authorize?response_type=code&client_id=cc91c61d00f8bb2ece1428035716b&state=900e06e2&redirect_uri=YOUR_APP_REDIRECT_URI
				window.open(hasHelloSign.urlRedirect, '_self');
			}
		} else if (userIsAuthorized === true) {
			console.log('user already auth use refresh token ');
			getAccessTokenFromRefresh(currentRefreshToken);
		}
	};

	const checkUrlForHelloOauth = async (urlToComp) => {
		var currentURL = window.location.href;
		//https://kavtek-unity-edits-testing.web.app/?code=c619aba059045068&state=900e06e2
		//900e06e2
		//var splitUrl = currentURL.split('?');
		var codeAndStateSplit = urlToComp.split('&');
		var codeId = codeAndStateSplit[0].replace('code=', '');
		var stateId = codeAndStateSplit[1].replace('state=', '');
		//var oAuthCode = data["oAuthCode"];
		//var oAuthState = data["oAuthState"];
		console.log('OAUTH CODE ID ' + codeId);
		console.log('OAUTH STATE ' + stateId);
		var toSend = {};
		toSend['oAuthCode'] = codeId;
		toSend['oAuthState'] = stateId;
		var getHelloOauthToken = await firebase
			.functions()
			.httpsCallable('HelloGetOAuthToken');

		var helloAuthToken;

		await getHelloOauthToken(toSend).then((result) => {
			console.log('results: ' + JSON.stringify(result));
			helloAuthToken = result;
			ORIGINAL_HREF.originalHREF['access_token'] =
				result['data']['access_token'];
			ORIGINAL_HREF.originalHREF['refresh_token'] =
				result['data']['refresh_token'];
			ORIGINAL_HREF.originalHREF['expires_in'] = result['data']['expires_in'];
			ORIGINAL_HREF.originalHREF['currentTime'] = Date.now();
		});

		var currentUserId = firebase.auth().currentUser.uid;

		console.log(
			'Refresh Token: ' + ORIGINAL_HREF.originalHREF['refresh_token']
		);

		await firebase
			.database()
			.ref('/users/' + currentUserId + '/helloSignRefreshToken')
			.set(ORIGINAL_HREF.originalHREF['refresh_token']);
	};

	console.log('CHECK IF WE HAVE CODE AND STATE');
	if (
		ORIGINAL_HREF.originalHREF.splitHref != null &&
		ORIGINAL_HREF.originalHREF.helloSignOAuth === false
	) {
		ORIGINAL_HREF.originalHREF.helloSignOAuth = true;
		if (
			ORIGINAL_HREF.originalHREF.splitHref.includes('code') &&
			ORIGINAL_HREF.originalHREF.splitHref.includes('state') &&
			oAuthDoneOnce === false
		) {
			checkUrlForHelloOauth(ORIGINAL_HREF.originalHREF.splitHref);
			oAuthDoneOnce = true;
		}
	}

	return <div></div>;
}

export default HelloOauth;
